module.exports = __webpack_public_path__ + "img/49.cc741a3a.png";